function isPageType(pageTypes) {
  const pageType = window.dataLayer?.[0]?.shoptet?.pageType;
  return pageTypes.includes(pageType);
}

const language = dataLayer[0].shoptet.language;

function handleHeader() {
  // Placeholder for search input
  const searchInput = document.querySelector(".query-input");
  if (searchInput) searchInput.placeholder = "Vyhledat";

  const headerTop = document.querySelector(".header-top");
  const navigationBtns = document.querySelector(".navigation-buttons");

  // moving account button
  const accountBtn =
    document.querySelector(".top-nav-button-login") ||
    document.querySelector(".top-nav-button-account");
  if (accountBtn && navigationBtns) navigationBtns.prepend(accountBtn);

  // moving menu and search toggles
  const menuToggle = document.querySelector(
    '.toggle-window[data-target="navigation"]'
  );
  const searchToggle = document.querySelector(
    '.responsive-tools .toggle-window[data-target="search"]'
  );
  if (menuToggle && headerTop) headerTop.prepend(menuToggle);
  if (searchToggle && headerTop) headerTop.prepend(searchToggle);

  // function to handle collection menus
  function handleCollectionMenu(itemSelector, bannerSelector, sessionKey) {
    const menuBanner = document.querySelector(bannerSelector);
    const menuItem = document.querySelector(itemSelector);

    if (!menuItem) return;

    const createExtItem = (item) => {
      const arrowSpan = document.createElement("span");
      // arrowSpan.classList.add("submenu-arrow");
      item.appendChild(arrowSpan);
      const itemParent = item.closest("li");
      if (itemParent) itemParent.classList.add("ext");
    };

    createExtItem(menuItem);

    if (menuBanner) {
      sessionStorage.setItem(sessionKey, menuBanner.innerHTML);

      const nextMenuLevel2 = menuItem.nextElementSibling;
      if (nextMenuLevel2?.classList.contains("menu-level-2"))
        nextMenuLevel2.remove();

      menuItem.after(menuBanner);
    } else if (sessionStorage.getItem(sessionKey)) {
      const menuLevel2 = document.createElement("ul");
      menuLevel2.classList.add("menu-level-2");
      menuLevel2.innerHTML = sessionStorage.getItem(sessionKey);
      menuItem.after(menuLevel2);
    }
  }

  // handleCollectionMenu(
  //   '.navigation-in a[href*="/raxi-klasicke-stojany/"]',
  //   "#footer .banner .collection-classix",
  //   "collectionClassixMenuBanner"
  // );

  // handleCollectionMenu(
  //   '.navigation-in a[href*="/kolekce-array/"]',
  //   "#footer .banner .collection-array",
  //   "collectionArrayMenuBanner"
  // );

  handleCollectionMenu(
    '.navigation-in a[href*="/o-nas/"]',
    "#footer .banner .vse-o-raxi",
    "vseRaxiMenuBanner"
  );

  handleCategoryTopMenu();
  handleLogo();
  handleName();

  window.addEventListener("resize", handleLogo);
}

function handleLogo() {
  const logoImg = document.querySelector(".site-name-wrapper img");
  if (!logoImg) return;
  logoImg.src =
    window.innerWidth <= 767
      ? "/user/documents/upload/miranda/Logo-mobile.png"
      : "/user/logos/logo.png";
}
function handleCategoryTopMenu() {
  // const menuForCategory = document.querySelector(".custom-footer__banner26");
  const menuForCategory = document.querySelector(
    "[class*='custom-footer__banner']:has(.menu-level-2.konfigurator-classix)"
  );

  const headerTop = document.querySelector(".header-top");
  if (menuForCategory && headerTop)
    headerTop.insertAdjacentElement("afterend", menuForCategory);
}
function handleName() {
  const cartPrice = document.querySelector('[data-testid="headerCartPrice"]');

  if (cartPrice && cartPrice.textContent.trim() === "Prázdný košík") {
    cartPrice.textContent = "Košík";
  }
}

handleHeader();

// document.addEventListener("ShoptetDOMContentLoaded", handleName);

function handleCarousel() {
  const carousel = document.querySelector("#carousel .carousel-inner");
  if (!carousel || document.querySelector(".carousel-dots")) return;
  const items = carousel.querySelectorAll(".item");
  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const target = mutations[i].target;
      if (target.classList.contains("active")) {
        const index = Array.prototype.indexOf.call(items, target);
        const dots = document.querySelectorAll(".carousel-dots li");
        for (let j = 0; j < dots.length; j++) {
          dots[j].classList.toggle("dot-active", j === index);
        }
      }
    }
  });
  const dotsList = document.createElement("ul");
  dotsList.classList.add("carousel-dots");
  for (let i = 0; i < items.length; i++) {
    const dotEl = document.createElement("li");
    if (i === 0) dotEl.classList.add("dot-active");
    dotEl.addEventListener("click", (e) => {
      e.preventDefault();
      const activeItem = carousel.querySelector(".item.active");
      activeItem.classList.remove("active");
      const targetItem = items[i];
      const img = targetItem.querySelector("img");
      if (!img.src) img.src = img.getAttribute("data-src");
      targetItem.classList.add("active");
    });
    observer.observe(items[i], {
      attributes: true,
      attributeFilter: ["class"],
    });
    dotsList.appendChild(dotEl);
  }
  carousel.appendChild(dotsList);
  const prevButton = document.querySelector(".carousel-control.left");
  const nextButton = document.querySelector(".carousel-control.right");
  const controlsContainer = document.createElement("div");
  controlsContainer.classList.add("carousel-controls", "container");
  controlsContainer.append(dotsList, prevButton, nextButton);
  carousel.appendChild(controlsContainer);
}
if (isPageType(["homepage"])) handleCarousel();

const swiperClassix = new Swiper(".swiperClassix", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 36,

  pagination: {
    el: ".classix-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".classix-next",
    prevEl: ".classix-prev",
  },
});

const swiperArray = new Swiper(".swiperArray", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 36,
  pagination: {
    el: ".array-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".array-next",
    prevEl: ".array-prev",
  },
});

// ! Category page
function handleTitleCategory() {
  const title = document.querySelector(".category-title");
  if (!title) return;

  const words = title.textContent.trim().split(" ");
  if (words.length > 1) {
    title.innerHTML = `<span class="first-word">${words[0]}</span> ${words
      .slice(1)
      .join(" ")}`;
  }
}
function insertColorSelect() {
  const categoryHeader = document.querySelector(".category-header");
  if (!categoryHeader) return;
  // Prevent duplicate insertion
  if (categoryHeader.querySelector(".color-filter")) return;

  const wrapper = document.createElement("div");
  wrapper.classList.add("color-filter");
  wrapper.innerHTML = `
    <label for="colorSelect" id="colorSelectLabel">Vyberte si z ?? dostupných barev:</label>
    <div id="colorSelect" class="custom-color-dropdown"></div>
    <p>Pokud je pro vás vhodnější zakázková barva sladěná s vaším projektem, není to problém. <a href="/kontakty/">Pojďme to probrat.</a></p>
  `;
  categoryHeader.prepend(wrapper);
}
async function loadColors() {
  const colorSelect = document.getElementById("colorSelect");
  const label = document.getElementById("colorSelectLabel");

  if (!colorSelect || !label) {
    console.error("colorSelect или label не найдены в DOM");
    return;
  }

  try {
    const res = await fetch(
      `https://metrie.mirandamedia.io/products/colors?categoryGuid=${categoryGuid}`
    );
    if (!res.ok) {
      console.error(`Error HTTP: ${res.status} ${res.statusText}`);
      return;
    }
    const data = await res.json();

    colorSelect.innerHTML = ""; // Clear previous
    const selected = document.createElement("div");
    selected.className = "selected-option";
    const optionsList = document.createElement("div");
    optionsList.className = "options-list";

    let firstColorValue = null;
    let firstColorHtml = null;

    data.values.forEach((color, idx) => {
      const option = document.createElement("div");
      option.className = "dropdown-option";
      option.innerHTML = `
        <span class="color-circle" style="background-color: #${color.color};"></span>
        <span class="option-title">${color.paramValue}</span>
      `;
      option.dataset.value = color.rawValue;
      option.addEventListener("click", () => {
        selected.innerHTML = `
          <span class="color-circle" style="background-color: #${color.color};"></span>
          <span class="option-title">${color.paramValue}</span>
        `;
        selected.dataset.value = color.rawValue;
        optionsList.classList.remove("show");
        updateImagesByColor(color.rawValue);
        sessionStorage.setItem("selectedCategoryColor", color.rawValue);
      });
      optionsList.appendChild(option);

      // Save first color info for default selection
      if (idx === 0) {
        firstColorValue = color.rawValue;
        firstColorHtml = `
          <span class="color-circle" style="background-color: #${color.color};"></span>
          <span class="option-title">${color.paramValue}</span>
        `;
      }
    });

    selected.addEventListener("click", () => {
      optionsList.classList.toggle("show");
      selected.classList.toggle("open");
    });

    colorSelect.appendChild(selected);
    colorSelect.appendChild(optionsList);

    // Update label with color count
    label.textContent = `Vyberte si z ${data.values.length} dostupných barev:`;

    // Set default selection: previously selected or first color
    let prevValue = sessionStorage.getItem("selectedCategoryColor");
    let optionToSelect = null;
    if (prevValue) {
      optionToSelect = colorSelect.querySelector(
        `.dropdown-option[data-value="${prevValue}"]`
      );
    }
    if (optionToSelect) {
      optionToSelect.click();
    } else if (firstColorValue && firstColorHtml) {
      selected.innerHTML = firstColorHtml;
      selected.dataset.value = firstColorValue;
      updateImagesByColor(firstColorValue);
      sessionStorage.setItem("selectedCategoryColor", firstColorValue);
    }
  } catch (e) {
    console.error("Ошибка при загрузке цветов:", e);
  }
}
async function updateImagesByColor(color) {
  try {
    showSpinner();

    const res = await fetch(
      `https://metrie.mirandamedia.io/products/images?categoryGuid=${categoryGuid}&color=${color}`
    );
    const data = await res.json();
    const productsAll = document.querySelectorAll(
      ".product:not(.banner-category)"
    );
    if (!productsAll.length) {
      console.error("No products found in the DOM");
      return;
    }
    productsAll.forEach((product) => {
      const guidProduct = product
        .querySelector(".p")
        .getAttribute("data-micro-identifier");

      const productImage = product.querySelector(".image img");
      const baseImageUrl =
        "https://cdn.myshoptet.com/usr/www.raxi.cz/user/shop/big/";
      for (const imgObj of data.images) {
        if (imgObj.guid === guidProduct) {
          if (productImage) {
            const filename = imgObj.image?.split("/").pop();
            if (filename) productImage.src = baseImageUrl + filename;

            productImage.alt = imgObj.code || productImage.alt;
          }
          break;
        }
      }
    });
    hideSpinner();
  } catch (e) {
    console.error("Error with updating images:", e);
  }
}
const categoryGuid = window.dataLayer?.[0]?.shoptet?.category?.guid;
if (
  isPageType(["category"]) &&
  (categoryGuid === "20f34e30-ab29-11e9-beb1-002590dad85e" ||
    categoryGuid === "90c22bb3-5428-11f1-acf3-bc24118e80f1")
) {
  document.addEventListener("DOMContentLoaded", () => {
    handleTitleCategory();
    insertColorSelect();
    loadColors();
  });

  ["ShoptetDOMPageContentLoaded", "ShoptetDOMPageMoreProductsLoaded"].forEach(
    (eventName) => {
      document.addEventListener(eventName, () => {
        handleTitleCategory();
        insertColorSelect();
        loadColors().then(() => {
          const colorSelect = document.getElementById("colorSelect");
          const selected = colorSelect?.querySelector(".selected-option");
          const prevValue =
            selected?.dataset.value ||
            sessionStorage.getItem("selectedCategoryColor");
          if (prevValue) updateImagesByColor(prevValue);
        });
      });
    }
  );
}
// ! Product detail page
function replaceUrlSegment(el, attr, from, to) {
  if (el.hasAttribute(attr)) {
    el.setAttribute(attr, el.getAttribute(attr).replace(from, to));
  }
}

function handleProductDetailPhoto() {
  const elements = document.querySelectorAll(
    "a[href], img[src], img[data-src], [data-href]"
  );
  elements.forEach((el) => {
    replaceUrlSegment(el, "href", "/big/", "/orig/");
    replaceUrlSegment(el, "href", "/related/", "/orig/");
    replaceUrlSegment(el, "src", "/big/", "/orig/");
    replaceUrlSegment(el, "src", "/related/", "/orig/");
    replaceUrlSegment(el, "data-src", "/big/", "/orig/");
    replaceUrlSegment(el, "data-src", "/related/", "/orig/");
    replaceUrlSegment(el, "data-href", "/big/", "/orig/");
    replaceUrlSegment(el, "data-href", "/related/", "/orig/");
  });
}

if (isPageType(["productDetail"])) {
  handleProductDetailPhoto();
  document.addEventListener(
    "ShoptetDOMContentLoaded",
    handleProductDetailPhoto
  );
  document.addEventListener(
    "ShoptetVariantAvailable",
    handleProductDetailPhoto
  );
}

const handleProductDetail = async () => {
  // Основные блоки
  const pInnerHeader = document.querySelector(".p-detail-inner-header");
  const shortDescription = document.querySelector(
    ".p-detail .p-short-description"
  );
  const variantList = document.querySelector(".p-detail .detail-parameters");
  const pDetailInfo = document.querySelector(".p-detail-info");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  const socialLinks = document.querySelector(".social-buttons-wrapper");

  if (!pInnerHeader || !pInfoWrapper) return;

  if (window.innerWidth > 767) {
    if (pDetailInfo) pInnerHeader.appendChild(pDetailInfo);
    pInfoWrapper.appendChild(pInnerHeader);
  }

  if (shortDescription) pInfoWrapper.appendChild(shortDescription);
  if (variantList) pInfoWrapper.appendChild(variantList);

  const th = document.querySelector("tr.variant-list > th");
  if (th && th.textContent.trim() === "Barva") {
    const labelCount = document.querySelectorAll(
      "tr.variant-list label.advanced-parameter"
    ).length;
    const selectCount = document.querySelectorAll(
      "tr.variant-list select.hidden-split-parameter option:not([data-choose])"
    ).length;
    const colorCount = labelCount || selectCount;
    let colorWords;
    if (colorCount === 1) {
      colorWords = "jedinečný odstín";
    } else if (colorCount >= 2 && colorCount <= 4) {
      colorWords = "jedinečné odstíny";
    } else {
      colorWords = "jedinečných odstínů";
    }
    th.textContent = `${colorCount} ${colorWords} na výběr`;
  }

  const customAddToCart = document.createElement("div");
  customAddToCart.classList.add("add-to-cart-wrapper");

  const productPrices = document.querySelector(".p-final-price-wrapper");
  const productQuantity = document.querySelector(".add-to-cart .quantity");
  const addToCart = document.querySelector(".add-to-cart");

  if (productPrices) customAddToCart.appendChild(productPrices);

  const availabilityValue = document.querySelector(
    ".p-info-wrapper .availability-value"
  );
  if (availabilityValue) {
    const label = availabilityValue.querySelector(".availability-label");
    const amount = availabilityValue.querySelector(".availability-amount");
    if (label && amount) {
      amount.style.color = label.style.color;
    }

    pInfoWrapper.appendChild(availabilityValue);
  }

  if (productQuantity) customAddToCart.appendChild(productQuantity);
  if (addToCart) customAddToCart.appendChild(addToCart);

  pInfoWrapper.appendChild(customAddToCart);

  const linkIconsWrapper = document.querySelector(
    ".p-info-wrapper .link-icons"
  );
  if (linkIconsWrapper) {
    const chatIcon = linkIconsWrapper.querySelector("a.chat span");
    if (chatIcon) chatIcon.textContent = "Dotaz o produktu";
  }

  if (socialLinks) {
    pInfoWrapper.appendChild(socialLinks);
  }

  const thumbnails = document.querySelectorAll(
    ".p-thumbnails .p-thumbnail img"
  );
  const descriptionBlock = document.querySelector(".basic-description");

  let descriptionBlockWrapper = document.querySelector(
    ".basic-description-wrapper"
  );
  if (!descriptionBlockWrapper) {
    descriptionBlockWrapper = document.createElement("div");
    descriptionBlockWrapper.classList.add("basic-description-wrapper");
    descriptionBlock.insertAdjacentElement("afterend", descriptionBlockWrapper);
    descriptionBlockWrapper.appendChild(descriptionBlock);
  }
  const productBanner = descriptionBlock.querySelector(".o-nas-materials");
  if (productBanner) {
    descriptionBlockWrapper.insertAdjacentElement("afterend", productBanner);
  }

  const imageIndex = 0; // ← сюда введи нужный номер (начиная с 0 — первое, 1 — второе и т.д.)

  if (thumbnails.length > imageIndex && descriptionBlock) {
    const chosenThumbnail = thumbnails[imageIndex];

    const imgElement = document.createElement("img");
    const realSrc =
      chosenThumbnail.getAttribute("data-src") || chosenThumbnail.src;

    imgElement.src = realSrc;
    imgElement.alt = chosenThumbnail.alt || "";
    imgElement.style.maxWidth = "100%";

    descriptionBlockWrapper.prepend(imgElement);
  } else {
    console.warn("Obrázek s daným indexem neexistuje.");
  }
};

if (isPageType(["productDetail"])) handleProductDetail();

let productSwiper = null;
let originalStructure = null;
function initProductSwiper() {
  const productImage = document.querySelector(".p-image-wrapper");
  const pImage = productImage?.querySelector(".p-image");

  if (window.innerWidth <= 767) {
    const thumbnails = document.querySelectorAll(".p-thumbnail");

    if (
      thumbnails.length &&
      productImage &&
      !document.querySelector(".product-swiper")
    ) {
      if (!originalStructure && pImage) {
        originalStructure = pImage.cloneNode(true);
      }

      const swiperContainer = document.createElement("div");
      swiperContainer.classList.add("swiper", "product-swiper");

      const swiperWrapper = document.createElement("div");
      swiperWrapper.classList.add("swiper-wrapper");

      const mainImageLink = document.querySelector(".p-image > a.p-main-image");
      if (mainImageLink) {
        const firstSlide = document.createElement("div");
        firstSlide.classList.add("swiper-slide");

        const clonedLink = mainImageLink.cloneNode(true);
        firstSlide.appendChild(clonedLink);
        swiperWrapper.appendChild(firstSlide);

        thumbnails.forEach((thumb, index) => {
          if (index > 0) {
            const imgUrl = thumb.getAttribute("href");
            const slide = document.createElement("div");
            slide.classList.add("swiper-slide");

            const aEl = document.createElement("a");
            aEl.classList.add("p-main-image");
            aEl.href = imgUrl;

            const imgEl = document.createElement("img");
            imgEl.src = imgUrl;

            aEl.appendChild(imgEl);
            slide.appendChild(aEl);
            swiperWrapper.appendChild(slide);
          }
        });
      }

      const navigation = document.createElement("div");
      navigation.classList.add("swiper-navigation");
      navigation.innerHTML = `
        <div class="swiper-pagination"></div>
      `;

      swiperContainer.appendChild(swiperWrapper);
      swiperContainer.appendChild(navigation);

      if (pImage) {
        pImage.innerHTML = "";
        pImage.appendChild(swiperContainer);

        productSwiper = new Swiper(".product-swiper", {
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
    }
  } else {
    if (productSwiper) {
      productSwiper.destroy(true, true);
      productSwiper = null;
    }

    if (originalStructure && pImage) {
      pImage.innerHTML = originalStructure.innerHTML;
    }
  }
}

initProductSwiper();

let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initProductSwiper();
  }, 250);
});

function createColorDropdown() {
  const wrapper = document.querySelector("#parameter-id-4");
  if (!wrapper) return;

  const labels = wrapper.querySelectorAll("label.advanced-parameter");
  if (!labels.length) return;

  const parameterId = wrapper.dataset.parameterId;
  const variantData =
    (window.shoptet &&
      window.shoptet.variantsSplit &&
      window.shoptet.variantsSplit.necessaryVariantData) ||
    {};

  wrapper.style.display = "none";

  const dropdown = document.createElement("div");
  dropdown.className = "custom-color-dropdown";

  const selected = document.createElement("div");
  selected.className = "selected-option";
  selected.textContent = "Zvolte si odstín";

  const optionsList = document.createElement("div");
  optionsList.className = "options-list";

  labels.forEach((label) => {
    const input = label.querySelector('input[type="radio"]');
    const colorSpan = label.querySelector(".advanced-parameter-inner");
    const nameSpan = label.querySelector(".parameter-value");

    const color = colorSpan.style.backgroundColor;
    const title = nameSpan?.textContent?.trim();

    const variant = variantData[`${parameterId}-${input.value}`];
    const availabilityName = variant?.availabilityName || "";
    const availabilityColor = variant?.availabilityColor || "";
    const availabilityHtml = availabilityName
      ? `<span class="option-availability" style="color: ${availabilityColor};">${availabilityName}</span>`
      : "";

    const optionHtml = `
      <span class="color-circle" style="background-color: ${color};"></span>
      <span class="option-title">${title}</span>
      ${availabilityHtml}
    `;

    const option = document.createElement("div");
    option.className = "dropdown-option";
    option.innerHTML = optionHtml;

    option.addEventListener("click", () => {
      selected.innerHTML = optionHtml;
      input.click();
      optionsList.classList.remove("show");
    });

    optionsList.appendChild(option);
  });

  selected.addEventListener("click", () => {
    optionsList.classList.toggle("show");
    selected.classList.toggle("open");
  });

  dropdown.appendChild(selected);
  dropdown.appendChild(optionsList);
  wrapper.insertAdjacentElement("afterend", dropdown);
}

if (isPageType(["productDetail"])) createColorDropdown();

// ! Cart page
function updateCartHeaders() {
  const headerStep2 =
    document.querySelector(".cart-header li.step-2 a span") ||
    document.querySelector(".cart-header li.step-2 strong span");
  if (headerStep2) headerStep2.innerText = "Doprava a platba";

  const headerStep3 =
    document.querySelector(".cart-header li.step-3 a span") ||
    document.querySelector(".cart-header li.step-3 strong span");
  if (headerStep3) headerStep3.innerText = "Informace";
}

function adjustProductPrices() {
  const tableRows = document.querySelectorAll(".cart-table tr.removeable");
  tableRows.forEach((row) => {
    const finalInTotal = row.querySelector(".p-total .price-final");
    const priceCell = row.querySelector("td.p-price.p-cell");

    if (finalInTotal) {
      finalInTotal.classList.add("final-bold");
      if (window.innerWidth < 768) {
        if (priceCell && finalInTotal !== priceCell.previousElementSibling) {
          priceCell.before(finalInTotal);
        }
      } else {
        if (priceCell && finalInTotal !== priceCell.firstChild) {
          priceCell.prepend(finalInTotal);
        }
      }
    }
  });
}

function moveDiscountBlock() {
  const sidebarCart = document.querySelector(".sidebar-in-cart");
  const discountWrapper = document.querySelector(".cart-content .cart-summary");

  if (
    discountWrapper &&
    sidebarCart &&
    discountWrapper.parentElement !== sidebarCart
  ) {
    sidebarCart.prepend(discountWrapper);

    const discountInput = discountWrapper.querySelector("input");
    if (discountInput) discountInput.placeholder = "Vložte kód";

    const heading = discountWrapper.querySelector("h4");
    if (heading) heading.innerText = "Slevový kód";
  }
}

function moveNextStepBack() {
  const checkoutBox =
    document.querySelector(".checkout-box-wrapper") ||
    document.querySelector(".checkout-box");
  const cartContent = document.querySelector(".cart-content");
  const nextStepBack = document.querySelector(".next-step-back");

  if (!cartContent || !nextStepBack) return;

  const isMobile = window.innerWidth <= 767;

  if (isPageType(["cart", "billingAndShipping"])) {
    if (isMobile) {
      if (
        checkoutBox &&
        nextStepBack.parentElement !== checkoutBox.parentElement
      ) {
        checkoutBox.insertAdjacentElement("afterend", nextStepBack);
      }
    } else {
      if (nextStepBack.parentElement !== cartContent) {
        cartContent.appendChild(nextStepBack);
      }
    }
  }

  if (isPageType(["customerDetails"])) {
    const cartHeader = document.querySelector(".cart-header.step-2");

    if (cartHeader && nextStepBack.parentElement !== cartHeader.parentElement) {
      cartHeader.insertAdjacentElement("afterend", nextStepBack);
    }

    nextStepBack.textContent = "Zpět k dopravě a platbě";

    let backToShopBtn = document.querySelector(
      ".btn.btn-primary.back-to-shop[href='/']"
    );
    if (!backToShopBtn) {
      backToShopBtn = document.createElement("a");
      backToShopBtn.classList.add("btn", "btn-primary", "back-to-shop");
      backToShopBtn.href = "/";
      backToShopBtn.textContent = "Zpět do obchodu";
      cartContent.appendChild(backToShopBtn);
    }

    if (isMobile) {
      const cartContent = document.querySelector(
        "#checkoutSidebar .cart-content"
      );
      if (cartContent && !cartContent.contains(backToShopBtn)) {
        cartContent.appendChild(backToShopBtn);
      }
    }
  }
}

function moveExtraDelivery() {
  const extraDelivery = document.querySelector(".extra.delivery");
  const summaryWrapper = document.querySelector(".summary-wrapper");
  const nextStepButton = document.querySelector(".next-step.next-step--cart");

  if (!extraDelivery) return;

  if (window.innerWidth > 767) {
    if (
      nextStepButton &&
      extraDelivery.parentElement !== nextStepButton.parentElement
    ) {
      nextStepButton.insertAdjacentElement("afterend", extraDelivery);
    }
  } else {
    if (
      summaryWrapper &&
      extraDelivery.parentElement !== summaryWrapper.parentElement
    ) {
      summaryWrapper.insertAdjacentElement("afterend", extraDelivery);
    }
  }
}

function handleProductCart() {
  const rows = document.querySelectorAll(".cart-table tr.removeable");

  rows.forEach((row) => {
    const availability = row.querySelector(".p-availability.p-cell");
    const name = row.querySelector(".p-name");
    const mainLink = name?.querySelector(".main-link");

    if (availability && mainLink && window.innerWidth < 768) {
      if (availability.parentElement !== name) {
        mainLink.insertAdjacentElement("afterend", availability);
      }
    }
    const quantity = row.querySelector(".p-quantity.p-cell");
    const price = row.querySelector(".p-price.p-cell");
    if (quantity && price && window.innerWidth < 768) {
      if (quantity.parentElement !== price) {
        quantity.prepend(price);
      }
    }
  });
}
function handleCart() {
  updateCartHeaders();
  adjustProductPrices();
  moveDiscountBlock();
  moveNextStepBack();
  moveExtraDelivery();
}
if (isPageType(["cart", "billingAndShipping", "customerDetails"])) {
  document.addEventListener("DOMContentLoaded", handleProductCart);
  document.addEventListener("ShoptetDOMCartContentLoaded", handleProductCart);
  document.addEventListener(
    "ShoptetDOMCartContentUpdated",
    adjustProductPrices
  );

  window.addEventListener("resize", () => {
    if (window.innerWidth < 768) {
      handleProductCart();
    }
  });
  handleCart();
  document.addEventListener("DOMContentLoaded", handleCart);
  document.addEventListener("ShoptetDOMCartContentLoaded", handleCart);
}

// ! O nas page
function handleAboutPage() {
  const oNasTopImage = document.querySelector(".o-nas-top-image");
  const oNasIntroSection = document.querySelector(".o-nas-intro-section");
  const oNasHistorySection = document.querySelector(".o-nas-history-section");
  const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
  if (oNasTopImage && breadcrumbs && oNasIntroSection && oNasHistorySection) {
    breadcrumbs.insertAdjacentElement("afterend", oNasTopImage);
    oNasTopImage.insertAdjacentElement("afterend", oNasIntroSection);
    oNasIntroSection.insertAdjacentElement("afterend", oNasHistorySection);
  }
}

if (document.body.classList.contains("in-o-nas")) {
  handleAboutPage();
}
